import React from 'react'
import { useParams } from 'react-router-dom'
import { useGoBackOrRedirect } from '@@partner:helpers/hooks/location'

import ProductGroupForm from '@components/catalog/productGroup/ProductGroupForm'

import { ROUTE_CATALOG_CATEGORIES, ROUTE_PRODUCT_GROUPS } from '@@partner:config/routes'

export default function ProductGroupPage () {

  const { groupId, brandSlug } = useParams<any>()
  const redirectToCatalog = useGoBackOrRedirect(ROUTE_PRODUCT_GROUPS, {
    brandSlug
  })

  return (
    <div className="CatalogCategoryPage">
      <h1 className="u-heading">
        {groupId ? 'Редактирование' : 'Добавление'}
      </h1>
      <ProductGroupForm groupId={groupId} onSaved={redirectToCatalog} />
    </div>
  )
}
